import React, { useState } from "react";
import styled from "styled-components";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const TopNotice = ({
  message = "🚀 Welcome back, developer! New features are live today.",
  background = "#151121",
  color = "#ffffff",
}) => {
  const [visible, setVisible] = useState(true);

  return (
    <AnimatePresence>
      {visible && (
        <NoticeWrapper
          as={motion.div}
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.4 }}
          style={{ background, color }}
        >
          <Content>
            <NoticeText>{message}</NoticeText>
            <CloseButton onClick={() => setVisible(false)}>
              <X size={18} />
            </CloseButton>
          </Content>
        </NoticeWrapper>
      )}
    </AnimatePresence>
  );
};

export default TopNotice;

/* ---------------- Styled Components ---------------- */

const NoticeWrapper = styled.div`
  width: 100%;
  padding: 8px 20px;
  position: relative;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
`;

const NoticeText = styled.span`
  font-size: 0.9rem;
  text-align: center;
  font-weight: 500;
  flex: 1;
  padding-right: 32px; /* space for close icon */
`;

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s ease;

  &:hover {
    opacity: 0.7;
    transform: translateY(-50%) scale(1.1);
  }
`;
